import { render, staticRenderFns } from "./simulador.html?vue&type=template&id=2c799ac2&scoped=true&"
import script from "./simulador.js?vue&type=script&lang=js&"
export * from "./simulador.js?vue&type=script&lang=js&"
import style0 from "./simulador.scss?vue&type=style&index=0&id=2c799ac2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c799ac2",
  null
  
)

export default component.exports